//#region IMPORT
import React, { useState } from 'react';
import M_FILE_BASIC_03 from './M_FILE_BASIC_03';
import Global from '../../../../Services/Common/Global';
import Commons from '../../../../Services/Common/Common';
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useSearch1 } from './M_FILE_BASIC_03_Query';
//#endregion

function M_FILE_BASIC_03F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [pdfImages, setPdfImages] = useState([]);
  //#endregion

  //#region 이벤트

  //#endregion

  //#region 쿼리
  useSearch1({
    onSuccess: async (rows) => {
      const reportData = rows?.[0];
      if (!reportData || reportData?.type === 'Error') {
        setPdfImages([]);
        return;
      }

      setLoading(true);
      const get = (obj, ...keys) =>
        keys.reduce((v, k) => v ?? obj?.[k], undefined);

      const data = Array.isArray(rows) ? rows : [reportData];

      // 작업일시 날짜 포맷 지정
      data.forEach((item) => {
        const workStartDate = get(item, 'workStartDate', 'WORK_START_DATE');
        const workEndDate = get(item, 'workEndDate', 'WORK_END_DATE');
        const date1 = workStartDate ? new Date(workStartDate) : null;
        const date2 = workEndDate ? new Date(workEndDate) : null;

        if (date1) {
          const year = date1.getFullYear();
          const month = String(date1.getMonth() + 1).padStart(2, '0');
          const day = String(date1.getDate()).padStart(2, '0');
          const hours = String(date1.getHours()).padStart(2, '0');
          const minutes = String(date1.getMinutes()).padStart(2, '0');
          const formattedStart = `${year}-${month}-${day} ${hours}:${minutes}`;
          item.WORK_START_DATE = formattedStart;
        }
        if (date2) {
          const year2 = date2.getFullYear();
          const month2 = String(date2.getMonth() + 1).padStart(2, '0');
          const day2 = String(date2.getDate()).padStart(2, '0');
          const hours2 = String(date2.getHours()).padStart(2, '0');
          const minutes2 = String(date2.getMinutes()).padStart(2, '0');
          item.WORK_END_DATE = `${year2}-${month2}-${day2} ${hours2}:${minutes2}`;
        }
      });

      const firstRow = data[0];
      const depSignPath = get(firstRow, 'depSignPath', 'DEP_SIGN_PATH');
      const smSignPath = get(firstRow, 'smSignPath', 'SM_SIGN_PATH');

      const imageUrlDep = depSignPath
        ? Global.file.useUrl + 'files/' + depSignPath
        : '';
      const imageUrlSm = smSignPath
        ? Global.file.useUrl + 'files/' + smSignPath
        : '';

      const base64Dep = depSignPath
        ? (await ConvertImageToBase64(imageUrlDep)).replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          )
        : '';
      const base64Sm = smSignPath
        ? (await ConvertImageToBase64(imageUrlSm)).replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          )
        : '';

      const headerData = {
        ...firstRow,
        DEP_SIGN_PATH: depSignPath ? base64Dep : '',
        SM_SIGN_PATH: smSignPath ? base64Sm : '',
      };

      const workTypesStr = get(firstRow, 'workTypes', 'WORK_TYPES') || '';
      const workTypesArray = workTypesStr
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);

      const tableDataMain = [
        {
          WT_001: workTypesArray.includes('WT_001'),
          WT_002: workTypesArray.includes('WT_002'),
          WT_003: workTypesArray.includes('WT_003'),
          WT_004: workTypesArray.includes('WT_004'),
          WT_005: workTypesArray.includes('WT_005'),
          WT_006: workTypesArray.includes('WT_006'),
        },
      ];

      const tableDataSingleRow = {};
      data.forEach((item) => {
        const keyBase = get(item, 'workTypeDtl', 'WORK_TYPE_DTL');
        const itemCheck = get(item, 'itemCheck', 'ITEM_CHECK');
        tableDataSingleRow[`CHECK_CONFIRM_${keyBase}`] = '';
        tableDataSingleRow[`CHECK_NOT_APPLICABLE_${keyBase}`] = '';

        if (itemCheck === '0') {
          tableDataSingleRow[`CHECK_CONFIRM_${keyBase}`] = 'true';
        } else if (itemCheck === '1') {
          tableDataSingleRow[`CHECK_NOT_APPLICABLE_${keyBase}`] = 'true';
        }
      });

      const serializedTable = JSON.stringify([tableDataSingleRow]);

      const printData = {
        FileName: 'PER_BASIC',
        HeaderData: JSON.stringify(headerData),
        TableDataMain: tableDataMain,
        TableData1: serializedTable,
        TableData2: serializedTable,
        TableData3: serializedTable,
        TableData4: serializedTable,
        TableData5: serializedTable,
        TableData6: serializedTable,
      };

      const pdfRes = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      if (
        !pdfRes?.data ||
        pdfRes?.headers['content-type'] !== 'application/pdf'
      ) {
        throw new Error('PDF 응답이 비어 있거나 PDF가 아닙니다.');
      }

      await RenderPdfToImages(await pdfRes.data.arrayBuffer());
      setLoading(false);
    },
  });
  //#endregion

  //#region 나머지 함수
  const ConvertImageToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) return '';
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('이미지 변환 오류:', error);
      return '';
    }
  };

  const RenderPdfToImages = async (pdfBlob) => {
    const pdf = await pdfjsLib.getDocument({ data: pdfBlob }).promise;
    const images = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport }).promise;
      images.push(canvas.toDataURL('image/png'));
    }

    setPdfImages(images);
  };

  const GoToPrevPage = () => {
    dispatch(CommonActions.setActiveStep(activeStep - 1));
  };
  //#endregion

  return (
    <M_FILE_BASIC_03
      pdfImages={pdfImages}
      loading={loading}
      goToPrevPage={GoToPrevPage}
    />
  );
}

export default M_FILE_BASIC_03F;
